/* ==========================================================================
   MasonryCarousel > Client
   ========================================================================== */

/* Modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const CarouselClient = require('../../../carousel/client/js');
const ProductCardSmallClient = require('../../../product-card-small/client/js');
const config = require('./config');

/**
 * MasonryCarousel component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function MasonryClient(selector = '[data-component="MasonryCarousel"]', configuration = {}) {
    if (elementExist(selector)) {
        /* Instance */
        const instance = {};

        /* Element */
        instance.element = document.querySelector(selector);

        /* Config */
        instance.config = { ...config(), ...configuration };

        /* Product cards */
        instance.cards = [...instance.element.querySelectorAll('[data-component="ProductCardSmall"]')].map(
            (item, index) =>
                ProductCardSmallClient(
                    `${selector} [data-component="ProductCardSmall"][data-type="${config().type.card}-${index}"]`,
                    {
                        ...configuration.card
                    }
                )
        );

        const bullets = instance.element.querySelector('[data-bullets]');

        /* Carousel */
        instance.carousel = CarouselClient(`${selector} [data-component="Carousel"]`, {
            ...config({ bullets }).carousel,
            ...configuration.carousel
        });

        /* Return */
        return instance;
    }
};
